<template>
  <div class="overtime-alert-tooltip-text z-10 aisea-text-14-400-white pl-1">
    <div class="alert-title">過去48時間以内に以下のアラートが発生している人数を表示しています。</div>
    <div class="alert-item">・過去24時間の労働時間が14時間超</div>
    <div class="alert-item">・過去7日間の労働時間が72時間超</div>
  </div>
</template>
<script>
export default {
  name: "TooltipTextOvertime",
  components: {},
};
</script>
<style lang="scss">
.overtime-alert-tooltip-text {
  .alert-title {
    margin-bottom: 10px;
  }
  .alert-item {
    font-weight: 600;
  }
}
</style>
